import { FinReportLayout } from "@features/layout";

export const FinReportPage = () => {
  return <FinReportLayout />;
};
